const ShimmerTextLoader = () => {
  return (
    <div className="my-2 flex w-full animate-pulse flex-col">
      <div className="mb-2 h-4 w-1/2  bg-gray-300"></div>
      <div className="mb-2 h-4 w-3/4  bg-gray-300"></div>
      <div className="h-4 w-1/4  bg-gray-300"></div>
    </div>
  );
};

export default ShimmerTextLoader;
